import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { Promotion } from '../../types/promotion';
import { PriceCardComponent } from '../price-card/price-card.component';

import { FormatPipe } from '@softline/ui-core';
@Component({
    selector: 'soft-promotion-card',
    imports: [PriceCardComponent,
    FormatPipe],
    templateUrl: './promotion-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './promotion-card.component.css'
})
export class PromotionCardComponent {
  promotion = input.required<Promotion>();
}
